export default "__VITE_ASSET__CkZHAwm0__"